export const Heading_Section_AI_Devkrest = {
    heading: "AI+DEVKREST"
}

export interface IAI_DevkrestStatItem {
    labelLines: string[];
    suffix: string;
    value: string;
}

export const Stats_Section_AI_Devkrest: IAI_DevkrestStatItem[] = [
    {
        value: "70",
        suffix: "%",
        labelLines: ["FASTER DELIVERY WITH AI-ASSISTED DEVELOPMENT"],
    },
    {
        value: "80",
        suffix: "%",
        labelLines: ["FEWER BUGS IN AI-SUPPORTED DEPLOYMENTS"],
    },
    {
        value: "2",
        suffix: "x",
        labelLines: ["MORE FEATURES SHIPPED PER SPRINT"],
    },
]; 